<mat-toolbar>
  <div class="container">
    <span class="customer-header-logo"> S9 </span>
    <div class="right-side-menu">
      <span>
        <img src="assets/img/location.svg" />
        Track
      </span>
      <span><img src="assets/img/bell.svg" /></span>
      <div class="dropdown" matTooltip="Profile">
        <a mat-button [matMenuTriggerFor]="menu"
          ><img
            class="header-profile"
            src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}"
          />Hi,
          <span style="text-transform: capitalize">{{ userName }}</span>
        </a>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="GoToProfile()">Profile</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="GoToTrips()">Trips</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="corporateLogout()">Logout</button>
        </mat-menu>
      </div>
    </div>
  </div>
</mat-toolbar>
